<i18n src="./resources/locales.json"></i18n>

<template>
  <v-card tile color="surface" class="ecs-notification-list-container custom-scrollbar">
    <EcsNotificationItem
      v-for="(notification, index) in notificationList"
      :key="index"
      :item="notification"
      :is-first="index === 0"
      @onItemClick="onItemClick"
    />
    <div v-if="!notificationList.length" class="text-center pa-4">
      {{ $t('empty_msg') }}
    </div>
    <div class="ecs-notification-fab">
      <slot></slot>
    </div>
  </v-card>
</template>

<script>
import EcsNotificationItem from '@/components/ecs-notifications-panel/ecs-notification-item/EcsNotificationItem';

export default {
  name: 'EcsNotificationList',

  components: {
    EcsNotificationItem
  },

  props: {
    notificationList: {
      type: Array,
      default() {
        return [];
      }
    }
  },

  methods: {
    onItemClick(item, action) {
      this.$emit('onItemClick', item, action);
    }
  }
};
</script>

<style scoped>
.ecs-notification-fab {
  position: fixed;
  right: 8px;
  bottom: 8px;
}
</style>
